import React from 'react';

import config from 'configs/app';
import useToast from 'lib/hooks/useToast';
import useAccount from 'lib/web3/useAccount';
import useAddChain from 'lib/web3/useAddChain';
import useProvider from 'lib/web3/useProvider';
import useSwitchChain from 'lib/web3/useSwitchChain';

const feature = config.features.blockchainInteraction;

const WalletChainGuardInner = () => {
  const account = useAccount();
  const { provider } = useProvider();
  const addChain = useAddChain();
  const switchChain = useSwitchChain();
  const toast = useToast();
  const hasTriedRef = React.useRef(false);

  const isConnected = !account.isDisconnected && account.address !== undefined;
  const isWrongChain = isConnected && account.chainId !== undefined && account.chainId !== Number(config.chain.id);

  React.useEffect(() => {
    if (!isConnected || !isWrongChain || !provider) {
      hasTriedRef.current = false;
      return;
    }

    if (hasTriedRef.current) {
      return;
    }

    hasTriedRef.current = true;

    const autoSwitch = async() => {
      try {
        await switchChain();
      } catch {
        try {
          await addChain();
          await switchChain();
          toast({
            position: 'top-right',
            title: 'Network added',
            description: `Switched to ${ config.chain.name }`,
            status: 'success',
            variant: 'subtle',
            isClosable: true,
          });
        } catch (error) {
          toast({
            position: 'top-right',
            title: 'Wrong network',
            description: `Please switch to ${ config.chain.name } in your wallet`,
            status: 'warning',
            variant: 'subtle',
            isClosable: true,
          });
        }
      }
    };

    autoSwitch();
  }, [ isConnected, isWrongChain, provider, addChain, switchChain, toast ]);

  return null;
};

const WalletChainGuard = () => {
  if (!feature.isEnabled) {
    return null;
  }
  return <WalletChainGuardInner/>;
};

export default WalletChainGuard;
